export default {
  form: {
    shipping_company_name: {
      label: 'Firma',
      placeholder: 'Wprowadź nazwę firmy',
    },
    shipping_phone_number: {
      label: 'Numer telefonu',
      placeholder: 'Wprowadź numer telefonu',
    },
    shipping_salutation: {
      label: 'Tytuł',
      options: {
        mr: 'Pan',
        mrs: 'Pani',
      },
    },
    shipping_first_name: {
      label: 'Imię',
      placeholder: 'Wprowadź imię',
    },
    shipping_last_name: {
      label: 'Nazwisko',
      placeholder: 'Wprowadź nazwisko',
    },
  },
  buttons: {
    back: 'Wstecz',
    next: 'Dalej',
  },
};
